/* eslint-disable */
export default function ellipsis(string, lengthParam)
{
    let finalString = `${string}`;

    return finalString.length > lengthParam ? finalString.substr(0, lengthParam) + ' ...' : finalString;
}